import React from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import ProfessionalAreasList from './ProfessionalAreasList';

const ProfessionalAreasSettingsPage: React.FC = () => {
    const pageHeader = {
        title: 'Áreas Profesionales',
        breadcrumb: [
            { name: 'Inicio', href: menuRoutes.dashboard.path },
            { name: 'Administración' },
            { name: 'Configuración General' },
            { name: 'Áreas profesionales', href: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.professionalAreas },
        ]
    };

    return (
        <div className='h-full overflow-auto scrollbar'>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
                className='border-b-4 border-dotted border-grey-500 top-0'
            />
            <div className="p-6">
                <ProfessionalAreasList />
            </div>
        </div>
    );
};

export default ProfessionalAreasSettingsPage;
